/*
 * @Author: sail web admin
 * @Date: 2020-05-07 10:18:45
 * @Last Modified by: yin
 * @Last Modified time: 2024-02-04 11:47:19
 * 登录模块中文
 */
export default {
  Login: '登 录',
  AdministratorLogin: '账号登录',
  MobileNumber: '手机号',
  password: '密码',
  SMSVerificationCode: '短信验证码',
  GetCode: '获取验证码',
  Resend: 's'
};
